import { observer } from 'mobx-react-lite';
import moment from 'moment-timezone';
import React from 'react';

import DriverList from 'pages/CrewTimeline/components/DriverList';
import TimelineGrid from 'pages/CrewTimeline/components/TimelineGrid';

import styles from './styles.module.css';

const CrewTimelineTable = observer(
	({
		timelineData,
		displayDays,
		onPreviousPeriod,
		onNextPeriod,
		onToday,
		canNavigatePrevious,
		canNavigateNext,
	}) => {
		const { drivers, dateRange, timezone } = timelineData;

		const visibleDateRange = dateRange.slice(0, displayDays || dateRange.length);
		const isCurrentPeriod = dateRange?.some((date) => moment().isSame(date.moment, 'day'));

		return (
			<div className={styles.tableContainer}>
				<DriverList drivers={drivers} isCurrentPeriod={isCurrentPeriod} onToday={onToday} />
				<TimelineGrid
					drivers={drivers}
					dateRange={visibleDateRange}
					timezone={timezone}
					displayDays={displayDays || visibleDateRange.length}
					onPreviousPeriod={onPreviousPeriod}
					onNextPeriod={onNextPeriod}
					canNavigatePrevious={canNavigatePrevious}
					canNavigateNext={canNavigateNext}
				/>
			</div>
		);
	}
);

export default CrewTimelineTable;
